import { useEffect } from 'react';
import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from '@emanetx/ui';
import { useMevcutOturum } from './oturum.js';
import { useTemaEtkisi, useTemaStore } from './tema.js';
import { yonlendirici } from './rotalar.js';
import { YuklemeYerlesimi } from './yerlesim.js';

export function App() {
  useTemaEtkisi();
  const tema = useTemaStore((s) => s.tema);
  const sorgu = useMevcutOturum();

  useEffect(() => {
    if (!sorgu.isLoading) {
      void yonlendirici.invalidate();
    }
  }, [sorgu.isLoading]);

  return (
    <>
      {sorgu.isLoading ? <YuklemeYerlesimi /> : <RouterProvider router={yonlendirici} />}
      <Toaster karanlik={tema === 'karanlik'} />
    </>
  );
}
